import { ADM_KH, KH }                                           from 'AppConfig/Config';
import { filterObjectStore, queryFilter, userContainsRole } from 'Redux/Query';

export const getEmployeeRoles = (state, filter = null) => {
    if(filter === null) {
        filter = queryFilter({sorting: { by: 'id', order: 'ASC' }})
    }

    // filter entferne ghost user role, damit diese nicht gesehen wird (hack für table config)
    const roles = filterObjectStore(state.employeeRole.employeeRoles.entries, filter).filter(({ id }) => id !== 9999);
    if(userContainsRole(state)([ADM_KH])) {
        return roles.filter(role => [KH, ADM_KH].includes(role.id))
    }

    return roles;
};
